<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Add Business Function
          <v-btn icon @click="$router.push('/businessfunction')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <!-- <v-col sm="2"
                ><label class="custom-form__label">Designation</label></v-col
              > -->
              <v-col sm="8">
                <v-select
                  v-model="domainName"
                  :item-text="(item) => item.domainName"
                  :items="domainList"
                  :item-value="(item) => item.id"
                  filled
                  append-icon="expand_more"
                  attach
                  label="Business Type/Domain"
                />
              </v-col>
            </v-row>
            <v-row v-if="isTypeOther" no-gutters>
              <v-col sm="8">
                <v-text-field
                  v-model="OtherBusinessType"
                  label="Enter Business Type"
                  :rules="businessRules"
                  filled
                />
                <!-- <font color="red" class="v-virtual-table">{{ text }}</font> -->
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="8">
                <v-text-field
                  v-model="valueStream"
                  label="Enter Value Stream"
                  :rules="nameRules"
                  filled
                />
                <!-- <font color="red" class="v-virtual-table">{{ text }}</font> -->
              </v-col>
            </v-row>
            <v-row no-gutters v-for="(step, i) in steps" :key="i">
              <v-col class="d-flex steps-col" sm="8">
                <v-text-field
                  v-model="step.stepName"
                  label="Enter Step "
                  :rules="stepRules"
                  filled
                />
              </v-col>
              <v-col class="mt-3 pl-2">
                <v-btn icon v-if="i == steps.length - 1" @click="addRow">
                  <v-icon color="#7F7F7F" size="18" class="font-weight-bold"
                    >add</v-icon
                  >
                </v-btn>
                <v-btn icon v-if="i > 0" @click="deleteRow(i)">
                  <v-icon color="#7F7F7F" size="16" class="font-weight-bold"
                    >remove</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
            <font color="red" class="v-virtual-table">{{ text }}</font>
            <v-row>
              <v-col class="text-center mt-8">
                <v-btn
                  :disabled="!valid || buttonCheck()"
                  class="primary_btn small"
                  depressed
                  @click="toFindDuplicate"
                  >Create Business Function</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { storeActions } from '@/store/actions.constants';
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    valid: false,
    stepName: null,
    isDuplicate: false,
    text: '',
    OtherBusinessType: null,
    isTypeOther: false,
    valueStream: null,
    businessObj: {},
    steps: [],
    domainName: '',
    domainId: null,
    search: '',
    loading: false,
    page: 1,
    itemsPerPage: 10,
    sortDesc: [],
    options: {},
    businessRules: [
      (v) => !!v || 'Business Type is Required',
      (v)=>v.length>0 && /^[^\s]/.test(v)|| 'Initial character should not be a space',
      (v) => !!(v && v.toString().split('  ').length <= 1) || 'Only one space is allowed in between 2 words',
      (v) => !!(v.trim().length>2&& v.trim().length<31) || "String length should be between 3 to 30",
     (v)=> /^[A-Za-z0-9_./# &+-]{3,30}$/.test(v)|| "Only _./#&+- special characters and numbers are allowed",
    ],
    nameRules: [
      (v) => !!v || 'Value Stream is Required',
      (v)=>v.length>0 && /^[^\s]/.test(v)|| 'Initial character should not be a space',
      (v) => !!(v && v.toString().split('  ').length <= 1) || 'Only one space is allowed in between 2 words',
      (v) => !!(v.trim().length>2&& v.trim().length<41) || "String length should be between 3 to 40",
      (v)=> /^[A-Za-z0-9_./# &+-]{3,40}$/.test(v)|| "Only _./#&+- special characters and numbers are allowed",
    ],
    stepRules: [
      (v) => !!v || 'Step is Required',
      (v)=>v.length>0 && /^[^\s]/.test(v)|| 'Initial character should not be a space',
      (v) => !!(v && v.toString().split('  ').length <= 1) || 'Only one space is allowed in between 2 words',
      (v) => !!(v.trim().length>2&& v.trim().length<71) || "String length should be between 3 to 70",
      (v)=> /^[A-Za-z0-9_./#() &+-]{3,70}$/.test(v)|| "Only _./#()&+- special characters and numbers are allowed",
    ],
  }),
  computed: {
    ...mapGetters({
      domains: 'businessFunction/getDomains',
    }),
    domainList() {
      return this.domains.data.map((domain) => ({
        id: domain.id,
        domainName: domain.name,
      }));
    },
  },
  watch: {
    domainName: {
      handler(val) {
        console.log(val);
        if (val === -1) {
          this.isTypeOther = true;
        } else {
          this.isTypeOther = false;
        }
      },
    },
  },
  async mounted() {
    await this.getDomainsList();
    this.steps.push({ stepName: '' });
    await this.getDomains({ page: 1, limit: 100 });
    this.domains.data.push({ id: -1, name: 'Other' });
  },
  methods: {
    ...mapActions({
      createBusinessFunction: 'businessFunction/createVsm',
      getDomains: 'businessFunction/getDomain',
    }),
    toFindDuplicate() {
    // let resultToReturn = false;
    // debugger
    // console.log('message',this.steps)
    var valueArr = this.steps.map(item =>  item.stepName.toLowerCase());
    var isDuplicate = valueArr.some((item, idx) => { 
             return valueArr.indexOf(item) != idx 
    });
    if (!isDuplicate) {
        this.addBusinessFunction()
        }
        else{
          this.text = "Same step names are not allowed..";
        }
    },
    async getDomainsList() {
      this.loading = true;
      // const { sortBy } = this.options;
      await this.getDomains({
        page: this.page,
        limit: 10,
        // search: this.search || '',
        // sort: sortBy[0],
        // desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    async addBusinessFunction() {
      // this.domainId = this.domainList.map((domain) => {
      //   return domain.id;
      // });
      // console.log(this.domainId);
      this.businessObj = await this.createBusinessFunction({
        domainId: this.domainName,
        domainName: this.isTypeOther ? this.OtherBusinessType : null,
        name: this.valueStream,
        steps: this.steps
      });
      if (this.businessObj.status === 200) {
        this.$router.push('/businessfunction');
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Business Function Created Successfully',
          timeout: 1000,
          color: 'success',
        });
      } else {
        this.text = this.businessObj.data.message;
      }
    },
    buttonCheck() {
      // var check = (val) => val.check === false;
      if (
        this.domainName === '' ||
        this.valueStream === null ||
        this.steps === []
      ) {
        return true;
      } else {
        return false;
      }
    },
    addRow() {
      this.steps.push({ stepName: '' });
    },
    deleteRow(index) {
      this.steps.splice(index, 1);
      this.isDuplicate = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
